<template>
    <div class="w-100 h-100 d-flex align-items-center "
         :class="alignmentClass ? alignmentClass : 'justify-content-center'">
        <i v-if="document[fieldName]" class="fas fa-check-circle text-success fa-lg" @click="updateValue(false)"
           :class="editable ? 'pointer' : ''"></i>
        <i v-else-if="!document[fieldName]" @click="updateValue(true)" :class="editable ? 'pointer' : ''"
           class="far fa-check-circle text-secondary fa-lg"></i>
    </div>
</template>

<script>
    import DataService from "../services/DataService";

    export default {
        name: 'CheckboxView',
        props: ['document', 'fieldName', 'editable', 'table', 'alignmentClass'],
        data() {
            return {
                service: new DataService(this.table.id)
            }
        },
        methods: {
            updateValue(value) {
                if(this.editable) {
                    this.document[this.fieldName] = value

                    if (this.document['id']) {
                        this.service.save(this.document)
                    }
                }
            }
        }
    }
</script>

<style>

</style>
